'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const MissionSection = () => {
  return (
    <section className="py-24 bg-background overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="absolute -top-12 -left-12 w-64 h-64 bg-primary/5 rounded-full blur-3xl animate-pulse" />
            <div className="relative z-10">
              <span className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-primary/10 text-primary font-caption text-xs font-semibold tracking-wider uppercase mb-6">
                <Icon name="RocketLaunchIcon" size={14} variant="solid" />
                <span>Our Mission</span>
              </span>
              <h2 className="font-heading text-4xl sm:text-5xl font-bold text-text-primary leading-[1.1] mb-8">
                Revolutionizing Car Care for <span className="text-primary italic">Every</span> Enthusiast
              </h2>
              <p className="font-body text-lg text-text-secondary leading-relaxed mb-6">
                Owning a premium vehicle shouldn't mean being held hostage by dealership prices. We founded AutoFixIQ to empower drivers nationwide with transparency, choice, and access to the finest independent specialists.
              </p>
              
              <div className="bg-card/50 border border-border p-6 rounded-xl mb-8 relative">
                <Icon name="ChatBubbleBottomCenterTextIcon" size={32} className="text-primary/20 absolute top-4 right-4" />
                <h3 className="font-heading text-xl font-bold text-text-primary mb-3">Our Story</h3>
                <p className="font-body text-sm text-text-secondary leading-relaxed mb-3">
                  "I own a BMW i3 and a Lexus NX 300h. When it came time for routine maintenance, a dealership quoted me over $200 just to replace a cabin air filter. Rather than paying it, I found a DIY video and realized it takes literally five minutes to do yourself, using a $20 OEM filter from Amazon.
                </p>
                <p className="font-body text-sm text-text-secondary leading-relaxed">
                  That five-minute fix changed everything. It boosted my confidence to tackle other maintenance myself, like wiper blades and batteries. I created AutoFixIQ so that anyone owning a car can feel that same empowerment, take control of their maintenance, and save money."
                </p>
              </div>
              <div className="space-y-6">
                {[
                  {
                    title: 'Empowering Owners',
                    desc: 'We provide tools to compare prices and find specialists who know your car as well as you do.',
                    icon: 'UserGroupIcon'
                  },
                  {
                    title: 'Supporting Locals',
                    desc: 'Connecting you with verified independent shops that form the backbone of our community.',
                    icon: 'HomeIcon'
                  }
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start space-x-4 p-4 rounded-xl transition-smooth hover:bg-muted/50">
                    <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-white shadow-elevation-sm flex items-center justify-center text-primary">
                      <Icon name={item.icon} size={24} />
                    </div>
                    <div>
                      <h4 className="font-heading text-lg font-semibold text-text-primary mb-1">{item.title}</h4>
                      <p className="font-body text-sm text-text-secondary">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="relative lg:ml-12">
            <div className="relative rounded-2xl overflow-hidden shadow-elevation-xl aspect-[4/3] bg-gradient-to-br from-primary/10 to-secondary/10 flex items-center justify-center border border-border/50">
              <div className="text-center p-8">
                <Icon name="WrenchScrewdriverIcon" size={80} className="text-primary/20 mx-auto mb-6" />
                <p className="font-heading text-2xl font-semibold text-primary/40">Mission Driven Design</p>
              </div>
              {/* Floating element for visual interest */}
              <div className="absolute bottom-6 -right-6 bg-white p-6 rounded-xl shadow-elevation-lg border border-border/50 max-w-[240px] animate-bounce-slow">
                 <div className="flex items-center space-x-2 mb-2">
                    <Icon name="CheckBadgeIcon" size={20} className="text-success" variant="solid" />
                    <span className="font-heading font-bold text-text-primary text-sm">40% Average Savings</span>
                 </div>
                 <p className="font-body text-xs text-text-secondary leading-tight">Users reported significant savings compared to local dealerships since our launch.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
